import {
  ticketSubmissionCopy,
  TicketSubmissionSuccessDetails,
} from '@twiliointernal/e2-commons-shared-definitions';
import { confirmationCardTypes } from '@twiliointernal/e2-commons-shared-ui';

const LOG_PREFIX = '[Ticket Submisson]';
const CHAT_TAG = (chatId: string): string => `hca_chat_id__${chatId}`;

const baseConfirmationProps: confirmationCardTypes.ConfirmationCardProps = {
  title: ticketSubmissionCopy.successDetails.title,
  calloutProps: {
    description: ticketSubmissionCopy.successDetails.callout.description,
    variant: 'neutral',
  },
  details: {},
  width: '100%',
};

const baseSuccessDetails: Partial<TicketSubmissionSuccessDetails> = {
  shouldHideForm: true,
  wasSuccessful: true,
};

const content =
  'Twilio powers personalized interactions and trusted global communications to connect you with customers.';
const path = '/submit';
const title = 'Twilio Help Center - Submit a Ticket';

const constants = {
  CHAT_TAG,
  LOG_PREFIX,
  baseConfirmationProps,
  baseSuccessDetails,
  content,
  path,
  title,
};

export default constants;
